export default __webpack_public_path__ + "static/media/binance.94f482ff.svg";